import { render, staticRenderFns } from "./TerminosView.vue?vue&type=template&id=8c9c40f2&scoped=true&"
import script from "./TerminosView.vue?vue&type=script&lang=ts&"
export * from "./TerminosView.vue?vue&type=script&lang=ts&"
import style0 from "./TerminosView.vue?vue&type=style&index=0&id=8c9c40f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c9c40f2",
  null
  
)

export default component.exports